import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import UseUserAuth from '@/Composables/UseUserAuth'

/**
 * Customer portal access based on the active customer's onboarding status.
 */
export default function UseCustomerAccess () {
    const page = usePage()
    const { isCustomer, isAdmin } = UseUserAuth(page.props.value.user)

    const activeCustomer = computed(() => page.props.value.activeCustomer)

    const canPlaceOrders = computed(() => {
        if (!isCustomer.value || !activeCustomer.value) {
            return false
        }

        return activeCustomer.value.onboarding_status === 'activated'
    })

    return {
        isCustomer,
        isAdmin,
        activeCustomer,
        canPlaceOrders,
    }
}
